var app 		= require('./src/app');
var stream 		= require('./src/stream');
app.stream 		= stream;
module.exports 	= app;